import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { InitialLoads } from './core-lib/misselaineous/initial-loads';
import { environment } from './environments/environment';
import { Fonts } from './utils/fonts';
import { Icons } from './utils/icons';

if (environment.production) {
    enableProdMode();
}

queueMicrotask(() => {
    Fonts.loadFont(Fonts.preload);
});
queueMicrotask(() => {
    Icons.loadIcons(Icons.preload);
});
InitialLoads.preload()
    .then(() => platformBrowserDynamic(InitialLoads.PROVIDERS).bootstrapModule(AppModule))
    .catch(err => console.error(err));
